/* unplugin-vue-components disabled */import { render } from "./people.vue?vue&type=template&id=41bf32ca&scoped=true"
import script from "./people.vue?vue&type=script&lang=js"
export * from "./people.vue?vue&type=script&lang=js"

import "./people.vue?vue&type=style&index=0&id=41bf32ca&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41bf32ca"]])

export default __exports__